import React from 'react';
import routerProvider from '@refinedev/react-router-v6';
import { IRoute } from '../interfaces/app.interface';
import {
    ApplicationList,
    ApplicationEdit,
    ApplicationCreate,
    ApplicationDossier,
} from '../pages/applications';
import {
    PreliminaryApplicationList,
    PreliminaryApplicationEdit,
    PreliminaryApplicationCreate,
} from '../pages/preliminary-application';
import {
    PreliminaryApplicationOPCList,
    PreliminaryApplicationOPCEdit,
    PreliminaryApplicationOPCCreate,
} from '../pages/preliminary-application-wp';
import { ActivityList } from '../pages/activity';
import { PharmasolShow, PharmasolList } from '../pages/pharmasol';
import { Login } from '../pages/login';
import { PreliminaryApplicationWpNew } from '../pages/preliminary-application-wp-new';
import { PreliminaryApplicationEVNew } from '../pages/preliminary-application-ev-new';
import { PreliminaryApplicationCTANew } from '../pages/preliminary-application-cta-new';

const AuthApplicationAdd = React.lazy(
    () => import('../components/layout/custom/auth-application-add')
);

const AuthForm = React.lazy(
    () => import('../components/layout/custom/auth-form')
);

const AuthHistory = React.lazy(
    () => import('../components/layout/custom/auth-history')
);

const AuthClinicalTrial = React.lazy(
    () => import('../components/layout/custom/auth-clinical-trial')
);

const AuthAppExternal = React.lazy(
    () => import('../components/layout/custom/auth-applications-external')
);

const AuthMenuForms = React.lazy(
    () => import('../components/layout/custom/auth-menu-forms')
);

const SpecShow = React.lazy(() => import('../pages/specs/show/show'));
const SpecList = React.lazy(() => import('../pages/specs/list/list'));

const customRoutes: IRoute[] = [
    { path: '/applications', element: <ApplicationList />, isPublic: false },
    {
        path: '/applications/create',
        element: <ApplicationCreate />,
        isPublic: false,
    },
    {
        path: '/applications/edit/:id',
        element: <ApplicationEdit />,
        isPublic: false,
    },
    {
        path: '/applications/edit/:id/dossier',
        element: <ApplicationDossier />,
        isPublic: false,
    },
    {
        path: '/applications/add',
        element: <AuthApplicationAdd />,
        isPublic: false,
    },
    {
        path: '/preliminary-applications',
        element: <PreliminaryApplicationList />,
        isPublic: false,
    },
    {
        path: '/preliminary-applications/create',
        element: <PreliminaryApplicationCreate />,
        isPublic: false,
    },
    {
        path: '/preliminary-applications/edit/:id',
        element: <PreliminaryApplicationEdit />,
        isPublic: false,
    },
    {
        path: '/preliminary-applications-ev-new',
        element: <PreliminaryApplicationEVNew />,
        isPublic: false,
    },
    {
        path: '/preliminary-applications-cta-new',
        element: <PreliminaryApplicationCTANew />,
        isPublic: false,
    },
    {
        path: '/preliminary-applications-wp',
        element: <PreliminaryApplicationOPCList />,
        isPublic: false,
    },
    {
        path: '/preliminary-applications-wp/create',
        element: <PreliminaryApplicationOPCCreate />,
        isPublic: false,
    },
    {
        path: '/preliminary-applications-wp/edit/:id',
        element: <PreliminaryApplicationOPCEdit />,
        isPublic: false,
    },
    {
        path: '/preliminary-applications-wp-new',
        element: <PreliminaryApplicationWpNew />,
        isPublic: false,
    },
    {
        path: '/form',
        element: <AuthForm />,
        isPublic: false,
    },
    {
        path: '/history',
        element: <AuthHistory />,
        isPublic: false,
    },
    {
        path: '/clinical-trial',
        element: <AuthClinicalTrial />,
        isPublic: false,
    },
    {
        path: '/applications-external',
        element: <AuthAppExternal />,
        isPublic: false,
    },
    {
        path: '/menu-forms',
        element: <AuthMenuForms />,
        isPublic: false,
    },
    {
        path: 'activity',
        element: <ActivityList />,
        isPublic: false,
    },
    {
        path: 'dictionaries',
        element: <PharmasolList />,
        isPublic: false,
    },
    {
        path: '/dictionaries/show/:id',
        element: <PharmasolShow />,
        isPublic: false,
    },
    {
        path: '/specs/:query',
        element: <SpecShow />,
        isPublic: false,
    },
    {
        path: '/specs',
        element: <SpecList />,
        isPublic: false,
    },
    {
        path: '/login',
        element: <Login />,
        isPublic: true,
    },
    // {
    //     element: <AuthAppExternal />,
    //     path: '/applications_external',
    //     layout: true,
    // },
    // {
    //     element: <AuthenticatedApplicationsFlow />,
    //     path: '/applications/flow',
    //     layout: true,
    // },
];

const routerProviderData = {
    ...routerProvider,
    routes: customRoutes,
};

export default routerProviderData;
